import { WorkingDocumentModel } from "models/WorkingDocumentModel";
import { createContext } from "react";
import { TriggerEvent } from "react-contexify";

export interface OneDriveSyncContextMenuContextProps {
  showContextMenu: (event: TriggerEvent, item: WorkingDocumentModel) => void;
}

export const OneDriveSyncContextMenuContext = createContext({} as OneDriveSyncContextMenuContextProps);
